import script from "./exam-sheet.vue?vue&type=script&lang=ts&setup=true"
export * from "./exam-sheet.vue?vue&type=script&lang=ts&setup=true"

import "./exam-sheet.vue?vue&type=style&index=0&id=55dc88ab&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55dc88ab"]])

export default __exports__